import { useEffect, useCallback } from 'react';
import { useGameStore } from '@campus/core';
import { Button, Icon } from '../ds/index.js';
import { useIsTouchDevice } from '../hooks/useIsMobile.js';

/**
 * LaunchPrompt — Badge flottant "Rejoindre" pour les zones area action="launch".
 *
 * Affiché en bas centre quand l'avatar est dans une zone launch.
 * Clic ou touche F → window.open(url, '_blank', 'noopener,noreferrer').
 * Disparaît quand activeArea est null (avatar sorti de la zone).
 */
export function LaunchPrompt() {
  const activeArea = useGameStore((s) => s.activeArea);
  const isTouch = useIsTouchDevice();

  const openLink = useCallback(() => {
    if (activeArea?.action === 'launch' && activeArea.url) {
      window.open(activeArea.url, '_blank', 'noopener,noreferrer');
    }
  }, [activeArea]);

  useEffect(() => {
    if (activeArea?.action !== 'launch') return;

    const handler = (e: KeyboardEvent) => {
      if (e.key === 'f' || e.key === 'F') {
        // Ne pas déclencher si l'utilisateur tape dans un input/textarea
        const tag = (e.target as HTMLElement)?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA') return;
        if (useGameStore.getState().adminPage) return; // campus en arrière-plan
        openLink();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [activeArea, openLink]);

  if (!activeArea || activeArea.action !== 'launch') return null;

  return (
    <div className="pl-float-bottom">
      <div className="pl-pop" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 6px 6px 14px', fontSize: 13 }}>
        <Icon name="grid" size={16} className="pl-menu-icon" />
        <span style={{ flex: 1, fontWeight: 500 }}>{activeArea.label}</span>
        {!isTouch && <kbd className="pl-key">F</kbd>}
        <Button variant="primary" size="sm" onClick={openLink}>Ouvrir</Button>
      </div>
    </div>
  );
}
